import { initializeVue } from "./top/initializeVue.es6";
import { Intro } from "./top/intro.es6";
import { Particle } from "./top/particle.es6";
import { fixedElement } from "./top/fixedElement.es6";
import { observeredSection } from "./top/observeredSection.es6";
import { setSplit } from "./top/setSplit.es6";
import { textAnimation } from "./top/textAnimation.es6";
class Main {
    constructor() {
        new Intro();
        new Particle();
        setSplit();
        this.init();
    }

    async init() {
        await initializeVue();
        observeredSection();
        textAnimation();
        fixedElement();
    }
}

new Main();
